var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape8 = function SvgShape8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 92,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.655 39.1c1.22-11.643 1.829-17.465 4.068-22.058 3.24-6.647 8.893-11.78 15.785-14.331C32.272.947 38.074.947 49.678.947h58.598c14.034 0 21.051 0 26.408 2.3 7.756 3.329 13.657 9.945 16.124 18.076 1.704 5.616.966 12.656-.508 26.736l-5.954 56.842c-1.219 11.642-1.829 17.464-4.068 22.057-3.24 6.647-8.893 11.779-15.785 14.331-4.764 1.764-10.566 1.764-22.171 1.764H43.725c-14.034 0-21.05 0-26.408-2.3-7.756-3.329-13.658-9.945-16.124-18.076-1.704-5.616-.966-12.656.508-26.736z",
    opacity: 0.1
  })));
};
export default SvgShape8;